// Cart.js
// version: 1.1.0
// author: Gavin Ballard
// license: MIT
(function () {
  var a,
    b,
    c,
    d,
    e,
    f,
    g,
    h = function (a, b) {
      return function () {
        return a.apply(b, arguments);
      };
    },
    i =
      [].indexOf ||
      function (a) {
        for (var b = 0, c = this.length; c > b; b++)
          if (b in this && this[b] === a) return b;
        return -1;
      };
  ((b = (function () {
    function a() {
      this.update = h(this.update, this);
    }
    return (
      (a.prototype.update = function (a) {
        var b, c, d;
        for (c in a) ((d = a[c]), "items" !== c && (this[c] = d));
        return (this.items = (function () {
          var c, d, f, g;
          for (f = a.items, g = [], c = 0, d = f.length; d > c; c++)
            ((b = f[c]), g.push(new e(b)));
          return g;
        })());
      }),
      a
    );
  })()),
    (e = (function () {
      function a(a) {
        ((this.propertyArray = h(this.propertyArray, this)),
          (this.update = h(this.update, this)),
          this.update(a));
      }
      return (
        (a.prototype.update = function (a) {
          var b, d;
          for (b in a) ((d = a[b]), "properties" !== b && (this[b] = d));
          return (this.properties = c.Utils.extend({}, a.properties));
        }),
        (a.prototype.propertyArray = function () {
          var a, b, c, d;
          ((c = this.properties), (d = []));
          for (a in c) ((b = c[a]), d.push({ name: a, value: b }));
          return d;
        }),
        a
      );
    })()),
    (c = {
      settings: {
        debug: !1,
        dataAPI: !0,
        requestBodyClass: null,
        rivetsModels: {},
        currency: null,
        moneyFormat: null,
        moneyWithCurrencyFormat: null,
        weightUnit: "g",
        weightPrecision: 0,
      },
      cart: new b(),
    }),
    (c.init = function (a, b) {
      return (
        null == b && (b = {}),
        c.configure(b),
        c.Utils.log("Initialising CartJS."),
        c.cart.update(a),
        c.settings.dataAPI &&
          (c.Utils.log('"dataAPI" setting is true, initialising Data API.'),
          c.Data.init()),
        c.settings.requestBodyClass &&
          (c.Utils.log('"requestBodyClass" set, adding event listeners.'),
          jQuery(document).on("cart.requestStarted", function () {
            return jQuery("body").addClass(c.settings.requestBodyClass);
          }),
          jQuery(document).on("cart.requestComplete", function () {
            return jQuery("body").removeClass(c.settings.requestBodyClass);
          })),
        c.Rivets.init(),
        jQuery(document).trigger("cart.ready", [c.cart])
      );
    }),
    (c.configure = function (a) {
      return (null == a && (a = {}), c.Utils.extend(c.settings, a));
    }),
    null == window.console &&
      ((window.console = {}), (window.console.log = function () {})),
    (d =
      'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.'),
    (c.Utils = {
      log: function () {
        return c.Utils.console(console.log, arguments);
      },
      warn: function () {
        return c.Utils.console(console.warn, arguments);
      },
      error: function () {
        return c.Utils.console(console.error, arguments);
      },
      console: function (a, b) {
        return c.settings.debug &&
          "undefined" != typeof console &&
          null !== console
          ? ((b = Array.prototype.slice.call(b)),
            b.unshift("[CartJS]:"),
            a.apply(console, b))
          : void 0;
      },
      wrapKeys: function (a, b, c, d) {
        var e, f, g, h;
        (null == b && (b = "properties"), null == d && (d = []), (h = {}));
        for (e in a)
          ((g = a[e]),
            (f = i.call(d, e) >= 0 ? e : "" + b + "[" + e + "]"),
            (h[f] = null != c ? c : g));
        return h;
      },
      unwrapKeys: function (a, b, c) {
        var d, e, f, g;
        (null == b && (b = "properties"), (e = {}));
        for (d in a)
          ((g = a[d]),
            (f = d.replace("" + b + "[", "").replace("]", "")),
            (e[f] = null != c ? c : g));
        return e;
      },
      extend: function (a, b) {
        var c, d;
        for (c in b) ((d = b[c]), (a[c] = d));
        return a;
      },
      clone: function (a) {
        var b, c;
        if (null == a || "object" != typeof a) return a;
        c = new a.constructor();
        for (b in a) c[b] = clone(a[b]);
        return c;
      },
      delete: function (a, b) {
        var c;
        return ((c = a[b]), delete a[b], c);
      },
      isArray:
        Array.isArray ||
        function (a) {
          return "[object Array]" === {}.toString.call(a);
        },
      ensureArray: function (a) {
        return c.Utils.isArray(a) ? a : null != a ? [a] : [];
      },
      formatMoney: function (a, b, e, f) {
        var g, h;
        return (
          null == f && (f = ""),
          f || (f = c.settings.currency),
          null != window.Currency &&
            f !== c.settings.currency &&
            ((a = Currency.convert(a, c.settings.currency, f)),
            null != (null != (g = window.Currency) ? g.moneyFormats : void 0) &&
              f in window.Currency.moneyFormats &&
              (b = window.Currency.moneyFormats[f][e])),
          null != (null != (h = window.Shopify) ? h.formatMoney : void 0)
            ? Shopify.formatMoney(a, b)
            : (c.Utils.warn(d), a)
        );
      },
      getSizedImageUrl: function (a, b) {
        var c, d;
        return null !=
          (null != (c = window.Shopify) && null != (d = c.Image)
            ? d.getSizedImageUrl
            : void 0)
          ? a
            ? Shopify.Image.getSizedImageUrl(a, b)
            : Shopify.Image.getSizedImageUrl(
                "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                b,
              ).replace("-_", "-")
          : a
            ? a
            : "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
      },
    }),
    (g = []),
    (f = !1),
    (c.Queue = {
      add: function (a, b, d) {
        var e;
        return (
          null == d && (d = {}),
          (e = {
            url: a,
            data: b,
            type: d.type || "POST",
            dataType: d.dataType || "json",
            cache: !!d.cache,
            success: c.Utils.ensureArray(d.success),
            error: c.Utils.ensureArray(d.error),
            complete: c.Utils.ensureArray(d.complete),
          }),
          d.updateCart && e.success.push(c.cart.update),
          g.push(e),
          f
            ? void 0
            : (jQuery(document).trigger("cart.requestStarted", [c.cart]),
              c.Queue.process())
        );
      },
      process: function () {
        var a;
        return g.length
          ? ((f = !0),
            (a = g.shift()),
            (a.complete = c.Queue.process),
            jQuery.ajax(a))
          : ((f = !1),
            void jQuery(document).trigger("cart.requestComplete", [c.cart]));
      },
    }),
    (c.Core = {
      getCart: function (a) {
        return (
          null == a && (a = {}),
          (a.type = "GET"),
          (a.updateCart = !0),
          c.Queue.add("/cart.js", { v: new Date().getTime() }, a)
        );
      },
      addItem: function (a, b, d, e) {
        var f;
        return (
          null == b && (b = 1),
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d, null, null, ["selling_plan"])),
          (f.id = a),
          (f.quantity = b),
          c.Queue.add("/cart/add.js", f, e),
          c.Core.getCart()
        );
      },
      addItems: function (a, b) {
        var d;
        return (
          null == b && (b = {}),
          (d = { items: a }),
          c.Queue.add("/cart/add.js", d, b),
          c.Core.getCart()
        );
      },
      updateItem: function (a, b, d, e) {
        var f;
        return (
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d, null, null, ["selling_plan"])),
          (f.line = a),
          null != b && (f.quantity = b),
          (e.updateCart = !0),
          c.Queue.add("/cart/change.js", f, e)
        );
      },
      removeItem: function (a, b) {
        return (null == b && (b = {}), c.Core.updateItem(a, 0, {}, b));
      },
      updateItemById: function (a, b, d, e) {
        var f;
        return (
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d, null, null, ["selling_plan"])),
          (f.id = a),
          null != b && (f.quantity = b),
          (e.updateCart = !0),
          c.Queue.add("/cart/change.js", f, e)
        );
      },
      updateItemQuantitiesById: function (a, b) {
        return (
          null == a && (a = {}),
          null == b && (b = {}),
          (b.updateCart = !0),
          c.Queue.add("/cart/update.js", { updates: a }, b)
        );
      },
      removeItemById: function (a, b) {
        var d;
        return (
          null == b && (b = {}),
          (d = { id: a, quantity: 0 }),
          (b.updateCart = !0),
          c.Queue.add("/cart/change.js", d, b)
        );
      },
      clear: function (a) {
        return (
          null == a && (a = {}),
          (a.updateCart = !0),
          c.Queue.add("/cart/clear.js", {}, a)
        );
      },
      getAttribute: function (a, b) {
        return a in c.cart.attributes ? c.cart.attributes[a] : b;
      },
      setAttribute: function (a, b, d) {
        var e;
        return (
          null == d && (d = {}),
          (e = {}),
          (e[a] = b),
          c.Core.setAttributes(e, d)
        );
      },
      getAttributes: function () {
        return c.cart.attributes;
      },
      setAttributes: function (a, b) {
        return (
          null == a && (a = {}),
          null == b && (b = {}),
          (b.updateCart = !0),
          c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b)
        );
      },
      clearAttributes: function (a) {
        return (
          null == a && (a = {}),
          (a.updateCart = !0),
          c.Queue.add(
            "/cart/update.js",
            c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""),
            a,
          )
        );
      },
      getNote: function () {
        return c.cart.note;
      },
      setNote: function (a, b) {
        return (
          null == b && (b = {}),
          (b.updateCart = !0),
          c.Queue.add("/cart/update.js", { note: a }, b)
        );
      },
    }),
    (a = null),
    (c.Data = {
      init: function () {
        return (
          (a = jQuery(document)),
          c.Data.setEventListeners("on"),
          c.Data.render(null, c.cart)
        );
      },
      destroy: function () {
        return c.Data.setEventListeners("off");
      },
      setEventListeners: function (b) {
        return (
          a[b]("click", "[data-cart-add]", c.Data.add),
          a[b]("click", "[data-cart-remove]", c.Data.remove),
          a[b]("click", "[data-cart-remove-id]", c.Data.removeById),
          a[b]("click", "[data-cart-update]", c.Data.update),
          a[b]("click", "[data-cart-update-id]", c.Data.updateById),
          a[b]("click", "[data-cart-clear]", c.Data.clear),
          a[b]("change", "[data-cart-toggle]", c.Data.toggle),
          a[b](
            "change",
            "[data-cart-toggle-attribute]",
            c.Data.toggleAttribute,
          ),
          a[b]("submit", "[data-cart-submit]", c.Data.submit),
          a[b]("cart.requestComplete", c.Data.render)
        );
      },
      add: function (a) {
        var b, d;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          (d = {}),
          (d.selling_plan = b.attr("data-cart-selling-plan")),
          c.Core.addItem(
            b.attr("data-cart-add"),
            b.attr("data-cart-quantity"),
            d,
          )
        );
      },
      remove: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.removeItem(b.attr("data-cart-remove"))
        );
      },
      removeById: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.removeItemById(b.attr("data-cart-remove-id"))
        );
      },
      update: function (a) {
        var b, d;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          (d = {}),
          (d.selling_plan = b.attr("data-cart-selling-plan")),
          c.Core.updateItem(
            b.attr("data-cart-update"),
            b.attr("data-cart-quantity"),
            d,
          )
        );
      },
      updateById: function (a) {
        var b, d;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          (d = {}),
          (d.selling_plan = b.attr("data-cart-selling-plan")),
          c.Core.updateItemById(
            b.attr("data-cart-update-id"),
            b.attr("data-cart-quantity"),
            d,
          )
        );
      },
      clear: function (a) {
        return (a.preventDefault(), c.Core.clear());
      },
      toggle: function () {
        var a, b;
        return (
          (a = jQuery(this)),
          (b = a.attr("data-cart-toggle")),
          a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b)
        );
      },
      toggleAttribute: function () {
        var a, b;
        return (
          (a = jQuery(this)),
          (b = a.attr("data-cart-toggle-attribute")),
          c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "")
        );
      },
      submit: function (a) {
        var b, d, e, f;
        return (
          a.preventDefault(),
          (b = jQuery(this).serializeArray()),
          (d = void 0),
          (f = void 0),
          (e = {}),
          jQuery.each(b, function (a, b) {
            return "id" === b.name
              ? (d = b.value)
              : "quantity" === b.name
                ? (f = b.value)
                : "selling_plan" === b.name
                  ? (e.selling_plan = b.value)
                  : b.name.match(/^properties\[[\w-_ ]*\]$/)
                    ? (e[b.name] = b.value)
                    : void 0;
          }),
          c.Core.addItem(d, f, c.Utils.unwrapKeys(e))
        );
      },
      render: function (a, b) {
        var d;
        return (
          (d = {
            item_count: b.item_count,
            total_price: b.total_price,
            total_price_money: c.Utils.formatMoney(
              b.total_price,
              c.settings.moneyFormat,
              "money_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0,
            ),
            total_price_money_with_currency: c.Utils.formatMoney(
              b.total_price,
              c.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0,
            ),
          }),
          jQuery("[data-cart-render]").each(function () {
            var a;
            return ((a = jQuery(this)), a.html(d[a.attr("data-cart-render")]));
          })
        );
      },
    }),
    "undefined" != typeof rivets && null !== rivets
      ? ((c.Rivets = {
          model: null,
          boundViews: [],
          init: function () {
            return c.Rivets.bindViews();
          },
          destroy: function () {
            return c.Rivets.unbindViews();
          },
          bindViews: function () {
            return (
              c.Utils.log("Rivets.js is present, binding views."),
              c.Rivets.unbindViews(),
              (c.Rivets.model = c.Utils.extend(
                { cart: c.cart },
                c.settings.rivetsModels,
              )),
              null != window.Currency &&
                (c.Rivets.model.Currency = window.Currency),
              jQuery("[data-cart-view]").each(function () {
                var a;
                return (
                  (a = rivets.bind(jQuery(this), c.Rivets.model)),
                  c.Rivets.boundViews.push(a)
                );
              })
            );
          },
          unbindViews: function () {
            var a, b, d, e;
            for (e = c.Rivets.boundViews, b = 0, d = e.length; d > b; b++)
              ((a = e[b]), a.unbind());
            return (c.Rivets.boundViews = []);
          },
        }),
        (rivets.formatters.eq = function (a, b) {
          return a === b;
        }),
        (rivets.formatters.includes = function (a, b) {
          return a.indexOf(b) >= 0;
        }),
        (rivets.formatters.match = function (a, b, c) {
          return a.match(new RegExp(b, c));
        }),
        (rivets.formatters.lt = function (a, b) {
          return b > a;
        }),
        (rivets.formatters.gt = function (a, b) {
          return a > b;
        }),
        (rivets.formatters.not = function (a) {
          return !a;
        }),
        (rivets.formatters.empty = function (a) {
          return !a.length;
        }),
        (rivets.formatters.plus = function (a, b) {
          return parseInt(a) + parseInt(b);
        }),
        (rivets.formatters.minus = function (a, b) {
          return parseInt(a) - parseInt(b);
        }),
        (rivets.formatters.times = function (a, b) {
          return a * b;
        }),
        (rivets.formatters.divided_by = function (a, b) {
          return a / b;
        }),
        (rivets.formatters.modulo = function (a, b) {
          return a % b;
        }),
        (rivets.formatters.prepend = function (a, b) {
          return b + a;
        }),
        (rivets.formatters.append = function (a, b) {
          return a + b;
        }),
        (rivets.formatters.slice = function (a, b, c) {
          return a.slice(b, c);
        }),
        (rivets.formatters.pluralize = function (a, b, d) {
          return (
            null == d && (d = b + "s"),
            c.Utils.isArray(a) && (a = a.length),
            1 === a ? b : d
          );
        }),
        (rivets.formatters.array_element = function (a, b) {
          return a[b];
        }),
        (rivets.formatters.array_first = function (a) {
          return a[0];
        }),
        (rivets.formatters.array_last = function (a) {
          return a[a.length - 1];
        }),
        (rivets.formatters.money = function (a, b) {
          return c.Utils.formatMoney(
            a,
            c.settings.moneyFormat,
            "money_format",
            b,
          );
        }),
        (rivets.formatters.money_with_currency = function (a, b) {
          return c.Utils.formatMoney(
            a,
            c.settings.moneyWithCurrencyFormat,
            "money_with_currency_format",
            b,
          );
        }),
        (rivets.formatters.weight = function (a) {
          switch (c.settings.weightUnit) {
            case "kg":
              return (a / 1e3).toFixed(c.settings.weightPrecision);
            case "oz":
              return (0.035274 * a).toFixed(c.settings.weightPrecision);
            case "lb":
              return (0.00220462 * a).toFixed(c.settings.weightPrecision);
            default:
              return a.toFixed(c.settings.weightPrecision);
          }
        }),
        (rivets.formatters.weight_with_unit = function (a) {
          return rivets.formatters.weight(a) + c.settings.weightUnit;
        }),
        (rivets.formatters.product_image_size = function (a, b) {
          return c.Utils.getSizedImageUrl(a, b);
        }),
        (rivets.formatters.moneyWithCurrency =
          rivets.formatters.money_with_currency),
        (rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit),
        (rivets.formatters.productImageSize =
          rivets.formatters.product_image_size))
      : (c.Rivets = { init: function () {}, destroy: function () {} }),
    (c.factory = function (a) {
      return (
        (a.init = c.init),
        (a.configure = c.configure),
        (a.cart = c.cart),
        (a.settings = c.settings),
        (a.getCart = c.Core.getCart),
        (a.addItem = c.Core.addItem),
        (a.addItems = c.Core.addItems),
        (a.updateItem = c.Core.updateItem),
        (a.updateItemById = c.Core.updateItemById),
        (a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById),
        (a.removeItem = c.Core.removeItem),
        (a.removeItemById = c.Core.removeItemById),
        (a.clear = c.Core.clear),
        (a.getAttribute = c.Core.getAttribute),
        (a.setAttribute = c.Core.setAttribute),
        (a.getAttributes = c.Core.getAttributes),
        (a.setAttributes = c.Core.setAttributes),
        (a.clearAttributes = c.Core.clearAttributes),
        (a.getNote = c.Core.getNote),
        (a.setNote = c.Core.setNote),
        (a.render = c.Data.render)
      );
    }),
    "object" == typeof exports
      ? c.factory(exports)
      : "function" == typeof define && define.amd
        ? define(["exports"], function (a) {
            return (c.factory((this.CartJS = a)), a);
          })
        : c.factory((this.CartJS = {})));
}).call(this);
